var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.4375C1 4.09131 2.09894 3 3.45455 3H16.5455C17.9011 3 19 4.09131 19 5.4375V13.5625C19 14.9087 17.9011 16 16.5455 16H3.45455C2.09894 16 1 14.9087 1 13.5625V5.4375Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28245 10.2646C4.69964 10.2646 3.34767 10.5312 3.34767 11.5979C3.34767 12.6649 4.6912 12.941 6.28245 12.941C7.86526 12.941 9.21723 12.6747 9.21723 11.6077C9.21723 10.5406 7.87407 10.2646 6.28245 10.2646Z",
    fill: "#EEF6FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28258 9.50006C7.26017 9.50006 8.04345 8.73438 8.04345 7.77947C8.04345 6.82457 7.26017 6.05889 6.28258 6.05889C5.30531 6.05889 4.52171 6.82457 4.52171 7.77947C4.52171 8.73438 5.30531 9.50006 6.28258 9.50006Z",
    fill: "#EEF6FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3911 6.8235C10.3911 6.61233 10.5663 6.44115 10.7824 6.44115H16.2606C16.4768 6.44115 16.652 6.61233 16.652 6.8235C16.652 7.03467 16.4768 7.20585 16.2606 7.20585H10.7824C10.5663 7.20585 10.3911 7.03467 10.3911 6.8235Z",
    fill: "#EEF6FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3911 8.35294C10.3911 8.14177 10.5663 7.97059 10.7824 7.97059H16.2606C16.4768 7.97059 16.652 8.14177 16.652 8.35294C16.652 8.56411 16.4768 8.73529 16.2606 8.73529H10.7824C10.5663 8.73529 10.3911 8.56411 10.3911 8.35294Z",
    fill: "#EEF6FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3911 9.88238C10.3911 9.67122 10.5663 9.50003 10.7824 9.50003H13.1302C13.3463 9.50003 13.5215 9.67122 13.5215 9.88238C13.5215 10.0936 13.3463 10.2647 13.1302 10.2647H10.7824C10.5663 10.2647 10.3911 10.0936 10.3911 9.88238Z",
    fill: "#EEF6FE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkVisa);
export default __webpack_public_path__ + "static/media/workVisa.97285e88.svg";
export { ForwardRef as ReactComponent };